module.exports = __webpack_public_path__ + "static/media/YM40_0.3c27ed22.jpg";